export const retrieveSubscription = "com.xmai.openapi.h5RequestProxy.userSubscription.UserSubscriptionService.retrieveSubscription"

export const getSimPluginType = "com.xmai.openapi.h5RequestProxy.userSubscription.UserSubscriptionService.getSimPluginType"

export const getUserSubscriptionPlans = "com.xmai.openapi.h5RequestProxy.userSubscription.UserSubscriptionService.getUserSubscriptionPlans"

export const getSimInfo = "com.xmai.openapi.h5RequestProxy.sim.SimService.getSimInfo"

export const getSimUsage = "com.xmai.openapi.h5RequestProxy.sim.SimService.getSimUsage"

export const getSimDailyUsage = "com.xmai.openapi.h5RequestProxy.sim.SimService.getSimDailyUsage"

// 国家/地区确认（俄区订阅判定链路）
export const getUserCountryStatus = "com.xmai.openapi.h5RequestProxy.account.UserCountryService.getUserCountryStatus"

export const confirmUserCountry = "com.xmai.openapi.h5RequestProxy.account.UserCountryService.confirmUserCountry"
